const Footer = () => {
  return <div />;
};

export default Footer;
